// Format poreznog broja (VAT number, BEZ dvoslovnog prefiksa države) za
// države EU, službeno objavljeno kroz VIES (ec.europa.eu/taxation_customs/vies).
// Format-only, bez checksuma — zrcali backend (TaxIdFormats.java), namjerno
// ista lista na oba mjesta. Države izvan ove mape nemaju validaciju — slobodan unos.
// DE (USt-IdNr.) se sprema s prefiksom (DE123456789) — vidi normalizeTaxId().
export const TAX_ID_FORMATS: Record<string, RegExp> = {
  AT: /^U\d{8}$/,
  BE: /^[01]\d{9}$/,
  BG: /^\d{9,10}$/,
  CY: /^\d{8}[A-Z]$/,
  CZ: /^\d{8,10}$/,
  DE: /^DE\d{9}$/,
  DK: /^\d{8}$/,
  EE: /^\d{9}$/,
  GR: /^\d{9}$/,
  ES: /^[A-Z0-9]\d{7}[A-Z0-9]$/,
  FI: /^\d{8}$/,
  FR: /^[A-Z0-9]{2}\d{9}$/,
  HR: /^\d{11}$/,
  HU: /^\d{8}$/,
  IE: /^\d{7}[A-Z]{1,2}$|^\d[A-Z]\d{5}[A-Z]$/,
  IT: /^\d{11}$/,
  LT: /^\d{9}$|^\d{12}$/,
  LU: /^\d{8}$/,
  LV: /^\d{11}$/,
  MT: /^\d{8}$/,
  NL: /^\d{9}B\d{2}$/,
  PL: /^\d{10}$/,
  PT: /^\d{9}$/,
  RO: /^\d{2,10}$/,
  SE: /^\d{12}$/,
  SI: /^\d{8}$/,
  SK: /^\d{10}$/
};

// Zrcali TaxIdFormats.normalize() na backendu: EU bez razmaka; DE velikim slovima i s "DE" ispred
// golih 9 znamenki (u korespondenciji se USt-IdNr. uvijek piše DE123456789).
export const normalizeTaxId = (country: string, taxId: string) => {
  if (!TAX_ID_FORMATS[country]) return taxId.trim();
  let compact = taxId.replace(/\s+/g, '');
  if (country === 'DE') {
    compact = compact.toUpperCase();
    if (/^\d{9}$/.test(compact)) compact = `DE${compact}`;
  }
  return compact;
};

export const isValidTaxId = (country: string, taxId: string) => {
  const pattern = TAX_ID_FORMATS[country];
  return !pattern || pattern.test(normalizeTaxId(country, taxId));
};
